export enum ContactFields {
  BAR_ASSOCIATION = 'barAssociation',
  BIRTHDAY = 'birthDay',
  CHARTERED = 'charteredProfessional',
  CHARTERED_FIELDS = 'charteredFields',
  CHARTERED_EXTRA_FIELDS = 'charteredExtraFields',
  FIRST_SURNAME = 'firstSurname',
  LAW_FIRM = 'lawFirm',
  LEGAL_TYPE = 'idLegalType',
  LOCATION_FIELDS = 'locationFields',
  NAME = 'name',
  NUMBER = 'number',
  NUMBER_COLLEGE = 'numberCollege',
  PERSON_TYPE = 'idPersonType',
  PROFESSIONAL_TYPE = 'idProfessionalType',
  SECOND_SURNAME = 'secondSurname',
  UNNUMBERED = 'unnumbered',
  WEB = 'web',
  AAPP_FIELDS = 'aappFields',
  LEGAL_COUNTRY = 'legalCountry',
  EAS_CODE = 'easCode'
}

export const DEFAULT_LEGAL_COUNTRY = {
  id: '73',
  iso: 'ES',
  name: 'España'
}
export const DEFAULT_EAS_CODE = {
  id: '53',
  code: '9920'
}
export const NaturalFields = [ContactFields.BIRTHDAY, ContactFields.FIRST_SURNAME, ContactFields.SECOND_SURNAME]
export const NaturalFieldsInFieldSet = [ContactFields.CHARTERED, ContactFields.PROFESSIONAL_TYPE]

export const LegalFields = [ContactFields.LEGAL_TYPE]
